module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-396.1e53684.woff2";